import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

const ServiceRegion = ({
  icon,
  title,
  desc,
  basePath = ""
}) => {

const navigate = useNavigate();

  // PREMIUM FADE
  const fadeUp = {
    hidden: {
      opacity: 0,
      y: 40,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.9,
        ease: [0.22, 1, 0.36, 1],
      },
    },
  };

  // REGION ITEM
  const regionVariant = {
    hidden: {
      opacity: 0,
      x: 18,
    },
    visible: (i) => ({
      opacity: 1,
      x: 0,
      transition: {
        delay: i * 0.08,
        duration: 0.55,
        ease: [0.22, 1, 0.36, 1],
      },
    }),
  };

const locations = [
  {
    name: "Perth CBD",
    slug: "/",
  },
  {
    name: "Baldivis",
    slug: "baldivis",
  },
  {
    name: "Joondalup",
    slug: "joondalup",
  },
  {
    name: "Leederville",
    slug: "leederville",
  },
  {
    name: "Canning Vale",
    slug: null,
  },
  {
    name: "Mandurah",
    slug: null,
  },
];

const getLocationPath = (slug) => {
  if (!slug) return null;

  return `/services/${slug}`;
};

  return (
    <>
      <motion.section
        className="service-region-section"
        initial="hidden"
        whileInView="visible"
        viewport={{
          once: true,
          amount: 0.18,
        }}
      >

        <div className="container service-region-container">

          {/* LEFT */}

          <motion.div
            className="service-region-left"
            variants={fadeUp}
          >

            <motion.div
              className="service-region-icon"
              whileHover={{
                y: -4,
                scale: 1.04,
              }}
              transition={{
                duration: 0.3,
              }}
            >

              <motion.img
                src={icon}
                alt={`${title} | LDL Settlement Services`}
                whileHover={{
                  rotate: -4,
                  scale: 1.05,
                }}
                transition={{
                  duration: 0.35,
                }}
              />

            </motion.div>

            <div className="service-region-content">

              <h3 className="card-heading">
                {title}
              </h3>

              <p className="section-text">
                {desc}
              </p>

            </div>

          </motion.div>

          {/* RIGHT */}

          <motion.div
            className="service-region-right"
            variants={fadeUp}
          >

            {/* COLUMN 1 */}

            <div className="service-region-column">

             {locations.slice(0, 3).map((item, i) => {

  const path = getLocationPath(item.slug);

  return (
    <motion.div
      className={`service-region-item ${
        path ? "region-clickable" : "region-disabled"
      }`}
      key={item.name}
      custom={i}
      variants={regionVariant}
      whileHover={
        path
          ? {
              x: 6,
            }
          : {}
      }
      transition={{
        duration: 0.25,
      }}
      onClick={() => {
        if (path) {
          navigate(path);
        }
      }}
    >

      <span className="region-dot"></span>

      <p className="section-text">
        {item.name}
      </p>

    </motion.div>
  );
})}
            </div>

            {/* COLUMN 2 */}

            <div className="service-region-column">

             {locations.slice(3, 6).map((item, i) => {

  const path = getLocationPath(item.slug);

  return (
    <motion.div
      className={`service-region-item ${
        path ? "region-clickable" : "region-disabled"
      }`}
      key={item.name}
      custom={i + 3}
      variants={regionVariant}
      whileHover={
        path
          ? {
              x: 6,
            }
          : {}
      }
      transition={{
        duration: 0.25,
      }}
      onClick={() => {
        if (path) {
          navigate(path);
        }
      }}
    >

      <span className="region-dot"></span>

      <p className="section-text">
        {item.name}
      </p>

    </motion.div>
  );
})}

            </div>

          </motion.div>

        </div>

      </motion.section>
    </>
  );
};

export default ServiceRegion;